/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const SectionUpdatePage = lazyLoad(
  () => import('./index'),
  module => module.SectionUpdatePage
);
